'use client';

import React, { HTMLAttributes, ReactNode } from 'react';

interface TextProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

/**
 * 共通フォームエラーテキスト
 * @param param0
 * @returns
 */
const FormErrorText: React.FC<TextProps> = ({ children, className, ...rest }) => {
  const defaultClassName = 'text-xs text-red-500 whitespace-pre-line break-all';

  return (
    <span className={`${defaultClassName} ${className || ''}`} {...rest}>
      {children}
    </span>
  );
};

export default FormErrorText;
